import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT } from '../utilities/FetchHelper';

class PetPolicyService {

  getPetPolicy(data) {
    const hotelCode = data.hotelCode
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_PET_POLICY
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }
    return fetchJSON(url, secureGET()).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }

  putPetPolicy(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_PET_POLICY
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    const putData = {
      hotelCode: data.hotelCode,
      petPolicy: data.petPolicy
    }


    return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }

}

export default new PetPolicyService();